import { inject, Injectable } from '@angular/core';
import { QualityControlViewService } from '../../../../views/quality-control/services/view.service';
import { Inspection } from '../../../../api/elite/types/inspections';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  QualityControlCreateInspectionComponent,
  QualityControlCreateInspectionTypes,
} from '../../../../common/quality-control/dialog/create-inspection/create-inspection.component';
import { HosesWorkOrder } from '../../models/work-order';
import { HosesQualityControlViewApiService } from '../api/view.service';
import { QualityControlItem } from '../../../../common/quality-control/model/item';
import { InspectionApiDto } from '../../../../api/elite/dto/inspection.dto';
import { HosesAuthQcService } from './auth.service';

@Injectable()
export class HosesQualityControlViewService extends QualityControlViewService {
  protected readonly apiRouter = inject(HosesQualityControlViewApiService);
  protected readonly authService = inject(HosesAuthQcService);

  override createInspectionDialog(
    item: QualityControlItem
  ): Observable<QualityControlCreateInspectionTypes['result']> {
    const minQuantity = this.authService.totalInspection() ? 2 : 5;
    return this.dialog
      .open(QualityControlCreateInspectionComponent, {
        data: {
          maxQuantity: item.quantityOnQc,
          minQuantity,
          inspectionStage: this.inspectionStage,
          department: this.department.NAME,
        },
      })
      .afterClosed();
  }

  override createInspectionRequest(
    item: HosesWorkOrder,
    data: QualityControlCreateInspectionTypes['result']
  ): Observable<InspectionApiDto['create']['result']> {
    return from(
      this.alertService.question('', 'Donde empezaras tu inspeccion?', {
        confirmButtonText: 'Visual',
        cancelButtonText: 'Medidas',
      })
    ).pipe(
      switchMap((alertRes) => {
        return this.apiRouter.createInspection({
          workOrderId: item.itemIdForInspection,
          quantity: data.quantity,
          details: {
            sourceShiftId: data.details.shiftId,
          },
          stageName: alertRes.isConfirmed
            ? 'Inspection Visual'
            : 'Inspection Measurement',
        });
      })
    );
  }

  override finishInspectionRequest(
    inspection: Inspection,
    notes?: string
  ): Observable<any> {
    return this.apiRouter
      .finishInspection(inspection.id, notes, {
        ifFailsSendToScrap: false,
        ifFailsSendTo: 'Rejected from QC',
        createReport: true,
      })
      .pipe(
        map((el) => {
          inspection.passed = el.passed;
          inspection.quantity = el.quantityToRemove;
          return inspection;
        })
      );
  }
}
